const tabButtons = document.querySelectorAll(
	'.block-tab-side-image-tab > .wp-block-button .wp-block-button__link'
);

const tabBlocks = document.querySelectorAll('.block-tab-side-image');

const adjustContentHeight = (tabBlock) => {
	// Find the currently active tab's content height within the specific tabBlock
	const activeContent = tabBlock.querySelector(
		'.block-tab-side-image-tab.active .block-content'
	);
	if (activeContent) {
		const activeContentHeight = activeContent.offsetHeight + 'px'; // Get the height

		// Set this height on the .block-tab-side-image__content container within the same tabBlock
		const contentContainer = tabBlock.querySelector(
			'.block-tab-side-image__content'
		);
		if (contentContainer) {
			contentContainer.style.height = activeContentHeight;
		}
	}
};

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tab-side-image');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-side-image-tab > .wp-block-button.active'
		);

		if (activeTabs.length) {
			activeTabs.forEach((activeTab) => {
				if (activeTab !== e.currentTarget.parentElement) {
					activeTab.classList.remove('active');
					activeTab.parentElement.classList.remove('active');
				}
			});
		}

		e.currentTarget.parentElement.classList.add('active');
		e.currentTarget.parentElement.parentElement.classList.add('active');

		const selectElement = tabBlock.querySelector(
			'.block-tab__mobile-select'
		);
		const tab = e.currentTarget.closest('.block-tab-side-image');

		if (tab && tab.hasAttribute('data-index') && selectElement) {
			selectElement.value = tab.getAttribute('data-index');
		}

		// Adjust the content height for the current tabBlock
		adjustContentHeight(tabBlock);
	}
};

const mobileSelect = (e) => {
	const tabBlock = e.currentTarget.closest('.block-tab-side-image');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-side-image-tab > .wp-block-button.active'
		);
		const currentTabButton = tabBlock.querySelector(
			'.block-tab-side-image-tab[data-index="' +
				e.currentTarget.value +
				'"] > .wp-block-button'
		);

		if (currentTabButton) {
			if (activeTabs.length) {
				activeTabs.forEach((activeTab) => {
					if (activeTab !== e.currentTarget.parentElement) {
						activeTab.classList.remove('active');
						activeTab.parentElement.classList.remove('active');
					}
				});
			}

			currentTabButton.classList.add('active');
			currentTabButton.parentElement.classList.add('active');
		}
	}
};

const initTabs = () => {
	if (tabButtons.length) {
		tabButtons.forEach((tabButton) => {
			tabButton.addEventListener('click', toggleTab);
		});
	}

	if (tabBlocks.length) {
		tabBlocks.forEach((tabBlock) => {
			const tabs = tabBlock.querySelectorAll('.block-tab-side-image-tab');

			if (tabs.length) {
				const selectElement = document.createElement('select');
				selectElement.classList.add('block-tab__mobile-select');

				// Create the wrapping div element
				const wrapperDiv = document.createElement('div');
				wrapperDiv.classList.add('block-tab__mobile-select-wrap');

				tabs.forEach((tab, index) => {
					const tabButton = tab.querySelector(
						'.block-tab-side-image-tab > .wp-block-button'
					);

					if (tabButton) {
						const option = document.createElement('option');
						option.value = index;
						option.text = tabButton.textContent;
						selectElement.appendChild(option);
						tab.setAttribute('data-index', index);

						if (index + 1 === tabs.length) {
							selectElement.addEventListener(
								'change',
								mobileSelect
							);
							// Append the selectElement to the wrapperDiv
							wrapperDiv.appendChild(selectElement);

							tab.parentElement.appendChild(wrapperDiv);
						}
					}

					tabButton.classList.add('initialized');

					if (0 === index) {
						tabButton.classList.add('active');
						tabButton.parentElement.classList.add('active');
					}
				});
			}
		});
	}

	document.querySelectorAll('.block-tab-side-image').forEach((tabBlock) => {
		adjustContentHeight(tabBlock); // Adjust content height for each tabBlock on load
	});

	// Set a timeout to run adjustContentHeight again after a few seconds for each tabBlock
	setTimeout(() => {
		document
			.querySelectorAll('.block-tab-side-image')
			.forEach((tabBlock) => {
				adjustContentHeight(tabBlock);
			});
	}, 1000);
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initTabs();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
